import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "catalog-check" }
const _hoisted_2 = { class: "flex-grow-1" }
const _hoisted_3 = { class: "fw-bold fs-5" }
const _hoisted_4 = { class: "text-end small text-nowrap" }
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-danger py-2 mb-3"
}
const _hoisted_7 = {
  key: 0,
  class: "mt-2 small"
}
const _hoisted_8 = { class: "mt-1" }
const _hoisted_9 = {
  key: 1,
  class: "mt-2 small"
}
const _hoisted_10 = { class: "mb-0 mt-1" }
const _hoisted_11 = {
  key: 1,
  class: "alert alert-danger py-2 mb-3 small"
}
const _hoisted_12 = {
  key: 2,
  class: "alert alert-danger py-2 mb-3 small"
}
const _hoisted_13 = { class: "mb-1" }
const _hoisted_14 = { class: "text-muted fw-normal small" }
const _hoisted_15 = { class: "table-responsive" }
const _hoisted_16 = { class: "table table-sm table-bordered mb-0 align-middle tabla" }
const _hoisted_17 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_18 = {
  key: 0,
  class: "text-success"
}
const _hoisted_19 = {
  key: 1,
  class: "text-danger fw-bold"
}
const _hoisted_20 = {
  key: 0,
  class: "text-warning fw-bold"
}
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_23 = {
  key: 1,
  class: "text-success"
}
const _hoisted_24 = {
  key: 2,
  class: "text-danger fw-bold"
}
const _hoisted_25 = { class: "text-muted" }
const _hoisted_26 = { class: "mb-3" }
const _hoisted_27 = { class: "table-responsive" }
const _hoisted_28 = { class: "table table-sm table-bordered mb-0 align-middle tabla" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  class: "text-warning fw-bold"
}
const _hoisted_31 = {
  key: 0,
  class: "small text-danger"
}
const _hoisted_32 = {
  key: 0,
  class: "text-danger fw-bold"
}
const _hoisted_33 = {
  key: 1,
  class: "text-success"
}
const _hoisted_34 = {
  key: 2,
  class: "small text-danger"
}
const _hoisted_35 = { class: "mb-2" }
const _hoisted_36 = { class: "small fw-bold" }
const _hoisted_37 = { class: "text-muted fw-normal" }
const _hoisted_38 = { class: "table-responsive" }
const _hoisted_39 = { class: "table table-sm table-bordered mb-0 tabla" }
const _hoisted_40 = { class: "table-light" }
const _hoisted_41 = {
  key: 0,
  class: "text-warning fw-bold"
}
const _hoisted_42 = { key: 1 }
const _hoisted_43 = {
  key: 0,
  class: "text-warning fw-bold"
}
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { class: "small" }
const _hoisted_46 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_47 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_48 = {
  key: 2,
  class: "fw-bold"
}
const _hoisted_49 = { class: "alert alert-secondary py-2 small mb-0" }
const _hoisted_50 = { class: "mb-1 mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["veredicto d-flex align-items-center gap-3 p-3 mb-3 rounded", _ctx.report.veredicto.ok ? 'v-verde' : 'v-rojo'])
    }, [
      _createElementVNode("i", {
        class: _normalizeClass(["fas fa-2x", 
          _ctx.report.veredicto.ok ? 'fa-circle-check' : 'fa-triangle-exclamation'
        ])
      }, null, 2),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.report.veredicto.ok
              ? "LO COMPROBABLE, EN VERDE"
              : "LO COMPROBABLE, EN ROJO"), 1),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "small" }, [
          _createTextVNode(" Los diez existen, quién se puede comprar, y la entrada al binario. "),
          _createElementVNode("strong", null, "Los números no entran en este veredicto"),
          _createTextVNode(" — no tienen respuesta correcta que una máquina pueda saber. Los juzgas tú, abajo. ")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _cache[1] || (_cache[1] = _createTextVNode(" base ", -1)),
          _createElementVNode("code", null, _toDisplayString(_ctx.report.databaseId), 1)
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.report.docs.length) + " documentos leídos", 1)
      ])
    ], 2),
    (_ctx.comprables.length || _ctx.viasAbiertas.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "fw-bold" }, [
            _createElementVNode("i", { class: "fas fa-cart-shopping" }),
            _createTextVNode(" SE PUEDEN COMPRAR DESPUÉS DEL REINICIO ")
          ], -1)),
          (_ctx.comprables.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.comprables.length) + " paquete(s) RETIRADO(s)", 1),
                _cache[2] || (_cache[2] = _createTextVNode(" siguen ofreciéndose (", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("code", null, "active", -1)),
                _cache[4] || (_cache[4] = _createTextVNode(" no está en ", -1)),
                _cache[5] || (_cache[5] = _createElementVNode("code", null, "false", -1)),
                _cache[6] || (_cache[6] = _createTextVNode("): ", -1)),
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comprables, (id) => {
                    return (_openBlock(), _createElementBlock("code", {
                      key: id,
                      class: "me-2 badge-id"
                    }, _toDisplayString(id), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.viasAbiertas.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.viasAbiertas.length) + " vía(s) de segundo piso", 1),
                _cache[7] || (_cache[7] = _createTextVNode(" abiertas — un upgrade o una promo en ", -1)),
                _cache[8] || (_cache[8] = _createElementVNode("code", null, "status: \"active\"", -1)),
                _cache[9] || (_cache[9] = _createTextVNode(" colgando de un paquete retirado. Apagar el padre y dejar esto encendido deja la puerta abierta igual: ", -1)),
                _createElementVNode("ul", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viasAbiertas, (v) => {
                    return (_openBlock(), _createElementBlock("li", { key: v }, [
                      _createElementVNode("code", null, _toDisplayString(v), 1)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "mt-2 small" }, [
            _createTextVNode(" Existir es correcto — quien los tiene tiene que poder "),
            _createElementVNode("strong", null, "renovar"),
            _createTextVNode(". Lo que no debe es "),
            _createElementVNode("strong", null, "venderse"),
            _createTextVNode(". ")
          ], -1))
        ]))
      : _createCommentVNode("", true),
    (_ctx.report.veredicto.faltan.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("strong", null, "Faltan " + _toDisplayString(_ctx.report.veredicto.faltan.length) + " documento(s):", 1),
          _createElementVNode("code", null, _toDisplayString(_ctx.report.veredicto.faltan.join(" · ")), 1),
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "mt-1" }, [
            _createTextVNode(" El remedio depende de la clase: los "),
            _createElementVNode("strong", null, "nuevos"),
            _createTextVNode(" los siembra el sembrador; "),
            _createElementVNode("code", null, "mmi-colombia"),
            _createTextVNode(" lo trae la "),
            _createElementVNode("strong", null, "copia"),
            _createTextVNode(" y sembrarlo sería inventárselo; un "),
            _createElementVNode("strong", null, "retirado"),
            _createTextVNode(" que falte rompe renovaciones viejas. ")
          ], -1))
        ]))
      : _createCommentVNode("", true),
    (_ctx.report.veredicto.vacios.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _cache[13] || (_cache[13] = _createElementVNode("strong", null, "Vacío(s):", -1)),
          _createElementVNode("code", null, _toDisplayString(_ctx.report.veredicto.vacios.join(" · ")), 1),
          _cache[14] || (_cache[14] = _createTextVNode(" — existe(n) sin un solo campo. Es el síntoma del PATCH sin ", -1)),
          _cache[15] || (_cache[15] = _createElementVNode("code", null, "updateMask", -1)),
          _cache[16] || (_cache[16] = _createTextVNode(": restáuralo del backup. ", -1))
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grupos, (grupo) => {
      return (_openBlock(), _createElementBlock("div", {
        key: grupo.clase,
        class: "mb-3"
      }, [
        _createElementVNode("h6", _hoisted_13, [
          _createTextVNode(_toDisplayString(grupo.titulo) + " ", 1),
          _createElementVNode("span", _hoisted_14, "— " + _toDisplayString(grupo.porQue), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("table", _hoisted_16, [
            _cache[19] || (_cache[19] = _createElementVNode("thead", { class: "table-light" }, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "documento"),
                _createElementVNode("th", null, "existe"),
                _createElementVNode("th", null, [
                  _createElementVNode("code", null, "active")
                ]),
                _createElementVNode("th", null, "¿se ofrece?"),
                _createElementVNode("th", null, "campos")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grupo.docs, (d) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: d.id
                }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("code", null, _toDisplayString(d.id), 1),
                    (d.gemelo)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                          _cache[17] || (_cache[17] = _createTextVNode(" ← copiado de ", -1)),
                          _createElementVNode("code", null, _toDisplayString(d.gemelo), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, [
                    (d.existe)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, "sí"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_19, "NO"))
                  ]),
                  _createElementVNode("td", null, [
                    (d.activoAusente)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, "AUSENTE"))
                      : (_openBlock(), _createElementBlock("code", _hoisted_21, _toDisplayString(d.activo), 1))
                  ]),
                  _createElementVNode("td", null, [
                    (d.activoEsperado === null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, [...(_cache[18] || (_cache[18] = [
                          _createTextVNode("no aplica — su palanca es el ", -1),
                          _createElementVNode("code", null, "endDate", -1)
                        ]))]))
                      : (d.activoOk)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, "correcto"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(d.clase === "retirado"
                        ? "SE OFRECE Y NO DEBE"
                        : "NO SE OFRECE Y DEBE"), 1))
                  ]),
                  _createElementVNode("td", _hoisted_25, _toDisplayString(d.totalCampos), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_26, [
      _cache[22] || (_cache[22] = _createElementVNode("h6", { class: "mb-1" }, [
        _createTextVNode(" La entrada al binario de los Lite "),
        _createElementVNode("span", { class: "text-muted fw-normal small" }, [
          _createTextVNode(" — es un "),
          _createElementVNode("strong", null, "OR"),
          _createTextVNode(": "),
          _createElementVNode("code", null, "binaryPoints > 0"),
          _createTextVNode(" O "),
          _createElementVNode("code", null, "addToBinaryTree !== false"),
          _createTextVNode(". Cerrar uno y dejar el otro no cierra nada. ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("table", _hoisted_28, [
          _cache[21] || (_cache[21] = _createElementVNode("thead", { class: "table-light" }, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "documento"),
              _createElementVNode("th", null, [
                _createElementVNode("code", null, "addToBinaryTree")
              ]),
              _createElementVNode("th", null, "tipo"),
              _createElementVNode("th", null, [
                _createElementVNode("code", null, "binaryPoints")
              ]),
              _createElementVNode("th", null, "¿entra al binario?")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.binario, (b) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: b.id
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("code", null, _toDisplayString(b.id), 1)
                ]),
                _createElementVNode("td", null, [
                  (b.tipoAddToBinaryTree !== 'undefined')
                    ? (_openBlock(), _createElementBlock("code", _hoisted_29, _toDisplayString(JSON.stringify(b.addToBinaryTree)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_30, "AUSENTE"))
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(
                    b.tipoAddToBinaryTree === 'boolean'
                      ? 'text-success'
                      : 'text-danger fw-bold'
                  )
                  }, _toDisplayString(b.tipoAddToBinaryTree), 3),
                  (
                    b.tipoAddToBinaryTree !== 'boolean' &&
                    b.tipoAddToBinaryTree !== 'undefined'
                  )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [...(_cache[20] || (_cache[20] = [
                        _createTextVNode(" tiene que ser un BOOLEANO. ", -1),
                        _createElementVNode("code", null, "\"false\"", -1),
                        _createTextVNode(" es una cadena, y ", -1),
                        _createElementVNode("code", null, "\"false\" !== false", -1),
                        _createTextVNode(" es cierto: vuelve a meterlos al binario. ", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("code", null, _toDisplayString(JSON.stringify(b.binaryPoints)), 1)
                ]),
                _createElementVNode("td", null, [
                  (b.entraAlBinario)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, "SÍ ENTRA"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_33, "no entra")),
                  (b.contradiccion)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, " CONTRADICCIÓN: dice que no entra y gana puntos. El paso de construir árboles se planta al verlo. "))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _cache[26] || (_cache[26] = _createElementVNode("h6", { class: "mb-1" }, [
        _createTextVNode(" Los números, contra el paquete del que se copiaron "),
        _createElementVNode("span", { class: "text-muted fw-normal small" }, [
          _createTextVNode(" — "),
          _createElementVNode("strong", null, "esto lo juzgas tú."),
          _createTextVNode(" Aquí no hay verde ni rojo porque no hay respuesta correcta que se pueda calcular. ")
        ])
      ], -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nuevos, (d) => {
        return (_openBlock(), _createElementBlock("div", {
          key: d.id,
          class: "mb-2"
        }, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("code", null, _toDisplayString(d.id), 1),
            _createElementVNode("span", _hoisted_37, [
              _cache[23] || (_cache[23] = _createTextVNode(" ← ", -1)),
              _createElementVNode("code", null, _toDisplayString(d.gemelo), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("table", _hoisted_39, [
              _createElementVNode("thead", _hoisted_40, [
                _createElementVNode("tr", null, [
                  _cache[24] || (_cache[24] = _createElementVNode("th", null, "campo", -1)),
                  _createElementVNode("th", null, _toDisplayString(d.id), 1),
                  _createElementVNode("th", null, _toDisplayString(d.gemelo), 1),
                  _cache[25] || (_cache[25] = _createElementVNode("th", null, null, -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(d.campos, (c) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: c.campo,
                    class: _normalizeClass({ 'fila-ausente': c.ausenteEnNuevo })
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("code", null, _toDisplayString(c.campo), 1)
                    ]),
                    _createElementVNode("td", null, [
                      (c.ausenteEnNuevo)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, "AUSENTE"))
                        : (_openBlock(), _createElementBlock("code", _hoisted_42, _toDisplayString(JSON.stringify(c.nuevo)), 1))
                    ]),
                    _createElementVNode("td", null, [
                      (c.ausenteEnGemelo)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_43, "AUSENTE"))
                        : (_openBlock(), _createElementBlock("code", _hoisted_44, _toDisplayString(JSON.stringify(c.gemelo)), 1))
                    ]),
                    _createElementVNode("td", _hoisted_45, [
                      (c.ausenteEnNuevo)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.implicaAusente(c.campo)), 1))
                        : (c.igual)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_47, "igual"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_48, "distinto"))
                    ])
                  ], 2))
                }), 128))
              ])
            ])
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_49, [
      _cache[30] || (_cache[30] = _createElementVNode("strong", null, "Lo que esta pantalla NO comprueba:", -1)),
      _createElementVNode("ul", _hoisted_50, [
        _cache[28] || (_cache[28] = _createElementVNode("li", null, [
          _createElementVNode("strong", null, "Si los números son los correctos."),
          _createTextVNode(" Precio, duración, puntos y bonos son decisiones comerciales. La pantalla los pone al lado del gemelo; el criterio es tuyo. ")
        ], -1)),
        _cache[29] || (_cache[29] = _createElementVNode("li", null, [
          _createElementVNode("strong", null, "Las subcolecciones que no se venden."),
          _createTextVNode(" Se miran "),
          _createElementVNode("code", null, "subscription-upgrades"),
          _createTextVNode(" y "),
          _createElementVNode("code", null, "promotions"),
          _createTextVNode(" por su "),
          _createElementVNode("code", null, "status"),
          _createTextVNode(", y nada más de lo que cuelgue debajo. ")
        ], -1)),
        _createElementVNode("li", null, [
          _cache[27] || (_cache[27] = _createElementVNode("strong", null, "Lo que pase después de mirar.", -1)),
          _createTextVNode(" Es una foto de " + _toDisplayString(_ctx.hora) + ". Si tocas el catálogo, vuelve a correrla. ", 1)
        ])
      ]),
      _cache[31] || (_cache[31] = _createStaticVNode("<div data-v-456a8a30> Sí comprueba, y antes se creía que no: <strong data-v-456a8a30>el tipo de <code data-v-456a8a30>addToBinaryTree</code></strong> (booleano contra la cadena <code data-v-456a8a30>&quot;false&quot;</code>) y <strong data-v-456a8a30>el OR de la colocación</strong> — el SDK conserva el tipo, así que aquí sí se distinguen. Lo que no los distingue es el <code data-v-456a8a30>curl</code> del comando, que los pinta como <code data-v-456a8a30>booleanValue</code> o <code data-v-456a8a30>stringValue</code>. </div>", 1))
    ])
  ]))
}